// quizService.js
// Service for handling quiz API calls

const API_BASE_URL = process.env.REACT_APP_API;


// Get quiz details
export const fetchQuizDetails = async (quizId) => {
  try {
    const response = await fetch(`${API_BASE_URL}/quize/user/${quizId}`, {
      method: 'GET',
      headers: {
        'Authorization': 'Bearer ' + sessionStorage.getItem('authToken') || '',
        'Content-Type': 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error(`Error fetching quiz: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Failed to fetch quiz details:', error);
    throw error;
  }
};

// Create quiz attempt
export const createQuizAttempt = async (quizId) => {
  try {
    const response = await fetch(`${API_BASE_URL}/quize/user/attempt/${quizId}`, {
      method: 'POST',
      headers: {
        'Authorization': 'Bearer ' + sessionStorage.getItem('authToken') || '',
        'Content-Type': 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error(`Error creating attempt: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Failed to create quiz attempt:', error);
    throw error;
  }
};

// Fetch quiz questions with answers
export const fetchQuizQuestions = async (quizId, attemptId, page = 1, limit = 10) => {
  try {
    const response = await fetch(`${API_BASE_URL}/quize/user/${quizId}/questions?attempt_id=${attemptId}&page=${page}&limit=${limit}`, {
      method: 'GET',
      headers: {
        'Authorization': 'Bearer ' + sessionStorage.getItem('authToken') || '',
        'Content-Type': 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error(`Error fetching questions: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Failed to fetch quiz questions:', error);
    throw error;
  }
};

export const saveQuizAnswer = async (attemptId, questionId, answerId) => {
  try {
    // Get auth token from session storage
    const authToken = sessionStorage.getItem('authToken');

    if (!authToken) {
      throw new Error('Authentication token not found');
    }

    const response = await fetch(`${API_BASE_URL}/quize/user/attempt/7/answer/save`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${authToken}`
      },
      body: JSON.stringify({
        attemptId: attemptId,
        questionId: questionId,
        answerId: answerId
      })
    });

    if (!response.ok) {
      throw new Error(`Error saving answer: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Failed to save answer:', error);
    throw error;
  }
};


export const submitQuiz = async (attemptId, quizeId) => {
  try 
  {
    if(!attemptId) 
    {
      throw new Error('Attempt ID is required');
    }
    const response = await fetch(`${API_BASE_URL}/quize/user/attempt/${quizeId}/submit?attemptId=${attemptId}`, 
    {
      method: 'POST',
      headers: 
      {
        'Authorization': 'Bearer ' + sessionStorage.getItem('authToken') || '',
        'Content-Type': 'application/json'
      }
    })
    if (!response.ok) 
    {
      throw new Error(`Error saving answer: ${response.status}`);
    }

    return await response.json();
  } catch (error) 
  {
    console.log(error);
    throw error;
  }
}

export const updateQuizTime = async (timeReaming, attemptId, quizeID) =>
  {
  const url = `${API_BASE_URL}/quize/user/attempt/${quizeID}/time?attemptId=${attemptId}`;

  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + sessionStorage.getItem('authToken') || ''
      },
      body: JSON.stringify({ timeReaming })
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const result = await response.json();
    console.log('Success:', result);
    return result;
  } catch (error) {
    console.error('Error updating quiz time:', error);
    throw error;
  }
}


export const fetchAttemptTime = async (quizId, attemptId) =>
{
  const url = `${API_BASE_URL}/quize/user/attempt/${quizId}/time?attempt_id=${attemptId}`;
  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Authorization": "Bearer " + sessionStorage.getItem("authToken") || "",
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;

  } catch (error) {
    console.error("Failed to fetch attempt time:", error);
    throw error;
  }
}
